import { Component, Input } from '@angular/core';

/// Tarjeta de indicador reutilizable: la misma "surface-card" con etiqueta + valor que se repetía,
/// literalmente igual, en cada indicador de la fila. El valor se proyecta como contenido (ng-content)
/// en lugar de un @Input(): cada indicador formatea su número con su propio pipe y su propio sufijo
/// (%, ms, decimales distintos), y forzar eso a una única expresión de binding habría sido más frágil
/// que dejar que quien la usa escriba su interpolación tal cual.
@Component({
    selector: 'app-platform-health-indicator',
    templateUrl: './platform-health-indicator.component.html',
    styleUrls: ['./platform-health-indicator.component.scss'],
    standalone: false
})
export class PlatformHealthIndicatorComponent {
    @Input() public label = '';
    @Input() public colClass = 'col-6 md:col-3 lg:col-2';
    /// Texto de ayuda contextual, opcional: si no se pasa, app-platform-health-help-icon no pinta
    /// el icono. Se centraliza aquí para que quien use el indicador no tenga que repetir el marcado
    /// del icono, solo el texto.
    @Input() public helpText: string | null = null;
}
